import { useGlobalStore } from '@vuejs/stores/GlobalStore'

import { getIdFromUrl } from './getIdFromUrl'

/**
 * Return id from url
 *   This is helpful when the agencyId or caregiverId is
 *   not in the store or access to store is unavailable.
 *   Sometimes it's not possible to find the agencyId for a given path
 *   in that case it returns 0.
 *
 * @example getAgencyId()
 * @returns number
 */

export function getAgencyId(): number {
	const globalStore = useGlobalStore()
	const pathname = window.location.pathname
	const pathArray = pathname.split('/')

	// Return null if the first segment is "franchisors" because that indicates that the ID is not an agency ID
	if (pathArray.length > 0 && pathArray.includes('franchisors')) {
		return 0
	}

	return globalStore.currentUser?.agency?.id ||
	globalStore.agency?.id ||
	getIdFromUrl()
}
